import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'

import Account from './modules/account'
import Dentists from './modules/dentists'
import Appointments from './modules/appointments'
import Users from './modules/users'
import Enquiries from './modules/enquiries'
import Tickets from './modules/tickets'
import Requests from './modules/requests'

Vue.use(Vuex)

const store = new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',

  state: {
    loading: true,
    boot: null,
    error: {
      login: null
    }
  },

  // Default modules (Required for all user types)
  modules: {
    account: Account,
    dentists: Dentists,
    appointments: Appointments
  },

  mutations: {
    setLoading(state, value) {
      if (value === false) {
        setTimeout(() => {
          state.loading = value
        }, 1000)
      } else {
        state.loading = value
      }
    },

    setError(state, data) {
      state.error[data.type] = data.value
    },

    setBoot(state, message) {
      if (message) {
        state.boot = message
      }
    },

    ...vuexfireMutations
  },

  actions: {
    // Internal Actions
    async load({ dispatch, getters, commit }, user) {
      commit('setBoot', 'Loading Account Data')
      await dispatch('account/storeRecord', user)
      commit('setBoot', 'Loading Profile Data')
      await dispatch('account/loadProfile')

      // Load Data - Admin
      if (getters['account/type'] === 'admin') {
        commit('setBoot', 'Loading Dentists')
        await dispatch('dentists/loadCollection')
        commit('setBoot', 'Loading Users')
        store.registerModule('users', Users)
        await dispatch('users/loadCollection')
        commit('setBoot', 'Loading Enquiries')
        store.registerModule('enquiries', Enquiries)
        await dispatch('enquiries/loadCollection')
        commit('setBoot', 'Loading Tickets')
        store.registerModule('tickets', Tickets)
        await dispatch('tickets/loadCollection')
        commit('setBoot', 'Loading Requests')
        store.registerModule('requests', Requests)
        await dispatch('requests/loadCollection')
      }

      // Load Data - Operator
      if (getters['account/type'] === 'operator') {
        commit('setBoot', 'Loading Dentists')
        await dispatch('dentists/loadCollection')
        commit('setBoot', 'Loading Appointments')
        await dispatch('appointments/loadCollection')
        commit('setBoot', 'Loading Users')
        store.registerModule('users', Users)
        await dispatch('users/loadCollection')
        commit('setBoot', 'Loading Enquiries')
        store.registerModule('enquiries', Enquiries)
        await dispatch('enquiries/loadCollection')
      }

      // Load Data - Dentist
      if (getters['account/type'] === 'dentist') {
        commit('setBoot', 'Loading Practice Data')
        await dispatch('dentists/loadCollection')
        commit('setBoot', 'Loading Appointments')
        await dispatch('appointments/loadCollection')
      }
    },

    wipe({ dispatch }) {
      dispatch('account/reset')
      dispatch('dentists/reset')
      dispatch('appointments/reset')

      if (store.state.users) {
        dispatch('users/reset')
        store.unregisterModule('users')
      }

      if (store.state.enquiries) {
        dispatch('enquiries/reset')
        store.unregisterModule('enquiries')
      }

      if (store.state.tickets) {
        dispatch('tickets/reset')
        store.unregisterModule('tickets')
      }

      if (store.state.requests) {
        dispatch('requests/reset')
        store.unregisterModule('requests')
      }
    },

    // External Actions
    async start({ dispatch, getters, commit }, user) {
      let response = false
      commit('setLoading', true)

      await dispatch('load', user)

      if (getters.status.global) {
        response = true
      }

      localStorage.setItem('userType', getters['account/type'])

      setTimeout(() => {
        commit('setLoading', false)
        commit('setBoot', 'Loading...')
      }, 1000)
      return response
    },

    async reset({ commit, dispatch }) {
      commit('setBoot', 'Clearing Data')
      commit('setLoading', true)
      localStorage.removeItem('userType')
      await dispatch('wipe')
      commit('setLoading', false)
      setTimeout(() => {
        commit('setBoot', 'Loading...')
      }, 500)
    },

    async reload({ commit, dispatch }, user) {
      commit('setLoading', true)
      dispatch('wipe')
      await dispatch('load', user)
      commit('setLoading', false)
    }
  },

  getters: {
    status: (state, getters) => {
      const account = state.account.status ? state.account.status.value : false
      const dentists = state.dentists.status ? state.dentists.status.value : false
      let appointments = false
      let users = false
      let enquiries = false
      let tickets = false
      let requests = false

      let check = false

      if (getters['account/type'] === 'admin') {
        users = state.users.status ? state.users.status.value : false
        enquiries = state.enquiries.status ? state.enquiries.status.value : false
        tickets = state.tickets.status ? state.tickets.status.value : false
        requests = state.requests.status ? state.requests.status.value : false
        check = account && dentists && users && enquiries && tickets && requests
      }

      if (getters['account/type'] === 'operator') {
        appointments = state.appointments.status ? state.appointments.status.value : false
        users = state.users.status ? state.users.status.value : false
        check = account && dentists && appointments && users
      }

      if (getters['account/type'] === 'dentist') {
        appointments = state.appointments.status ? state.appointments.status.value : false
        check = account && dentists && appointments
      }

      return {
        global: check,
        section: {
          account,
          dentists,
          appointments,
          users,
          enquiries,
          tickets,
          requests
        }
      }
    }
  }
})

export default store
